import { atom } from "jotai";

export const formInstanceAtom = atom(undefined);
export const colaboradoresAtom = atom([]);
export const tiposDocumentoAtom = atom([]);
export const loadingAtom = atom(false);
export const coloresAsignadosAtom = atom(['#0693E3']);